import axios from "axios";

import { InvalidationPayload } from "fe-shared-requests/src/components";

export const invalidatePickupRequest = (
  requestNumber: string,
  payload: InvalidationPayload
): Promise<void> =>
  axios
    .post(`pickupRequests/${requestNumber}/invalidate`, payload)
    .then(() => undefined);

export default invalidatePickupRequest;
